
import ToolBarBottom from '../../components/ToolBarBottom'
import Divider from 'vux/src/components/divider/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'


export default {
components: {
ToolBarBottom,
Divider,
Tab,
TabItem,
Cell,
CellBox,
Group,
GroupTitle,
Sticky,
XTable,
Timeline,
TimelineItem,
FormPreview
},
data () {
return {
fileDownloadUrl: this.$fileDownloadUrl,
orderid: '',
blno: '',
ieFlag: 'E',
state: '',
platcode: '',
tab1: true,
tab2: false,
tab3: false,
tab1_group1_showmore: false,
showCargoDetail: false,
showCtnDetail: false,
disabled: typeof navigator !== 'undefined' && /iphone/i.test(navigator.userAgent) && /ucbrowser/i.test(navigator.userAgent),
truck1Item: [{label: '产装时间', value: '2019-07-01 09:00'}, {label: '司机', value: '李师傅'}, {label: '手机号', value: '13812000012'}],
truck2Item: [{label: '产装时间', value: '2019-07-01 09:00'}, {label: '司机', value: '张师傅'}, {label: '手机号', value: '13812023012'}],
truckBtns: [{
style: 'primary',
text: '车辆跟踪',
onButtonClick: (name) => {
this.$Msgbox.alert(`clicking ${name}`)
}}],
orderInfo: {},
orderNodeList: [],
orderJGStatusList: [],
jgTips: '暂无海关动态信息'
}
},
mounted: function () {
this.orderid = this.$route.query.orderid
this.state = this.$route.query.state
this.platcode = this.$route.query.platcode
console.log('param: orderid: ' + this.orderid + ', state: ' + this.state + ', platcode: ' + this.platcode)
this.getOrderBaseInfo()
},
methods: {
onItemClick (index) {

},
/* 订单基本信息获取 */
getOrderBaseInfo: function () {
var that = this
var url = '/wxapi/order/getOrderBaseInfo?orderid=' + this.orderid + '&platcode=' + this.platcode + '&state=' + this.state

this.$axios.post(url, {}).then(function (res) {
if (res.meta.success) {
that.orderInfo = res.data
that.blno = that.orderInfo.BookingNo
if (that.orderInfo.imex === 'IM') {
that.ieFlag = 'I'
} else {
that.ieFlag = 'E'
}
} else {
console.error(res.meta.message)
if (res.redirect) {
window.location.href = res.data
} else {
that.$Msgbox.alert(res.meta.message, '异常提示')
}
}
}).catch(function (error) {
console.info(error)
})
},
/* 订单动态信息获取 */
showOrderStatus: function () {
var that = this
that.tab1 = false
that.tab2 = true
that.tab3 = false

var url = '/wxapi/order/getOrderStatusInfo?orderid=' + this.orderid + '&platcode=' + this.platcode + '&state=' + this.state
this.$axios.post(url, {}).then(function (res) {
if (res.meta.success) {
that.orderNodeList = res.data
} else {
console.error(res.meta.message)
if (res.redirect) {
window.location.href = res.data
} else {
that.$Msgbox.alert(res.meta.message, '异常提示')
}
}
}).catch(function (error) {
console.info(error)
})
},

showJGStatus: function () {
var that = this
that.tab1 = false
that.tab2 = false
that.tab3 = true
if (!that.$Utils.IsEmpty(that.blno)) {
that.jgTips = '正在查询...'
var url = '/wxapi/sw/getOrderSwStatusInfo?blno=' + that.blno + '&ieFlag=' + that.ieFlag
this.$axios.post(url, {}).then(function (res) {
if (res.meta.success) {
that.orderJGStatusList = res.data.list
if (that.orderJGStatusList.length < 1) {
that.jgTips = '暂无海关动态信息'
}
} else {
that.jgTips = '暂无海关动态信息'
console.error(res.meta.message)
if (res.redirect) {
window.location.href = res.data
} else {
that.$Msgbox.alert.show(res.meta.message, '异常提示')
}
}
}).catch(function (error) {
console.info(error)
})
} else {
that.orderJGStatusList = []
that.jgTips = '请提供提单号'
}
}
}
}



// WEBPACK FOOTER //
// ./src/pages/order/orderDetail.vue